var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"700","scrollable":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title'),_c('OrderTable',{attrs:{"loading":_vm.loading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }